import React from 'react';
import { Container } from './Container';
import { Label } from './Label';
export function About() {
  return <section className="border-b border-brand-gray300 py-[clamp(70px,10vw,140px)]" id="about" data-id="element-12" data-mp="2psi8f4rnwtsc">
      <Container data-id="element-13" data-mp="2tssmz5tissit">
        <div className="grid gap-12 md:grid-cols-[minmax(170px,0.65fr)_minmax(0,1.35fr)] md:gap-16" data-id="element-14" data-mp="2tsahrjovr3yr">
          <Label data-id="element-15" data-mp="2ytq6blq9nslw">About Us</Label>
          <div data-id="element-16" data-mp="2ypsm0wrycv0f">
            <h2 className="mb-8 max-w-[32ch] text-[clamp(1.75rem,3.6vw,3.75rem)] font-black leading-[1.02] tracking-[-0.035em]" data-id="element-17" data-mp="33rhwaa7cp4ng">
              A creative agency built to amplify athletes, artists, and innovators through community-driven storytelling and culture-shaping experiences.
            </h2>
            <div className="flex max-w-[60ch] flex-col gap-6 text-[clamp(16px,1.4vw,19px)] leading-[1.5] text-[#2a2a2a]" data-id="element-18" data-mp="3hiemjudt19rc">
              <p data-id="element-19" data-mp="3miix73s17a9n">
                At ABIE Agency, we exist to connect creative individuals from diverse backgrounds who share a common purpose—to grow, inspire, and build impact.
              </p>
              <p data-id="element-20" data-mp="2lrh6jojlw360">
                We elevate voices across Wellness, Fitness, Education, Fashion, Nutrition, and Entertainment through strategy, community, and innovation.
              </p>
            </div>
          </div>
        </div>
      </Container>
    </section>;
}